"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.rag.description': 'Skonfiguruj ustawienia RAG (Retrieval-Augmented Generation) dla przetwarzania wiedzy AI',
    'settings.rag.failedToLoad': 'Błąd ładowania ustawień RAG',
    'settings.rag.savedSuccessfully': 'Ustawienia RAG zapisane pomyślnie',
    'settings.rag.failedToSave': 'Błąd zapisywania ustawień RAG',
    'settings.rag.save': 'Zapisz Ustawienia RAG',
    'settings.rag.indexing.title': 'Ustawienia Indeksowania',
    'settings.rag.indexing.chunkSize': 'Rozmiar Fragmentu',
    'settings.rag.indexing.chunkSize.help': 'Maksymalna liczba znaków na fragment tekstu (100-10000)',
    'settings.rag.indexing.chunkOverlap': 'Nakładanie Fragmentów',
    'settings.rag.indexing.chunkOverlap.help': 'Liczba nakładających się znaków między fragmentami (0-1000)',
    'settings.rag.indexing.separators': 'Separatory Tekstu',
    'settings.rag.indexing.separators.placeholder': 'Wprowadź separatory oddzielone przecinkami (np. .\\n\\n, \\n)',
    'settings.rag.indexing.separators.help': 'Znaki lub ciągi używane do podziału tekstu na fragmenty. Użyj \\n dla nowych linii, \\t dla tabulatorów. Oddziel wiele wartości przecinkami.',
    'settings.rag.search.title': 'Ustawienia Wyszukiwania',
    'settings.rag.search.defaultMaxResults': 'Domyślna Maks. Liczba Wyników',
    'settings.rag.search.defaultMaxResults.help': 'Domyślna liczba wyników wyszukiwania do zwrócenia (1-50)',
    'settings.rag.search.maxResults': 'Maksymalna Liczba Wyników',
    'settings.rag.search.maxResults.help': 'Maksymalna dozwolona liczba wyników wyszukiwania (1-100)',
    'settings.rag.search.similarityThreshold': 'Próg Podobieństwa',
    'settings.rag.search.similarityThreshold.help': 'Minimalny wynik podobieństwa dla wyników wyszukiwania (0-1)',
};
